import { useStaticQuery } from "gatsby";
import React from "react";
import { useTranslation } from "react-i18next";
import Branch from "./branch";
import data from "./data";

import "./style.scss";

export const query = graphql`
  query {
    api {
      configContact {
        phoneNumber
        tollFree
        email
      }
    }
  }
`;

const Branches = () => {
  const apiData = useStaticQuery(query);
  const { t } = useTranslation();
  const contact = apiData.api.configContact;

  const data = [
    {
      header: t("contact.centralOffice"),
      title: "First Investment Bank",
      phones: [
        {
          type: "tel",
          number: contact.tollFree,
        },
        {
          type: "tel",
          number: contact.phoneNumber,
        },
      ],
      emails: [contact.email],
      swift: "BIC / SWIFT: FINVALTR",
      address: t("contact.address"),
    },
  ];

  return (
    <div className="branches">
      {data.map((branch) => (
        <Branch {...branch} />
      ))}
    </div>
  );
};

export default Branches;
